(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/registration/components/attendee/inc/custom-questions', '<panel-section>\n' + '  <panel-section-banner>\n' + '    <cpt-headline>Additional Questions</cpt-headline>\n' + '  </panel-section-banner>\n' + '  <panel-section-body>\n' + '    <form-table>\n' + '      <custom-fields questions="$ctrl.customQuestions" answers="$ctrl.registrant.answers">\n' + '      </custom-fields>\n' + '    </form-table>\n' + '  </panel-section-body>\n' + '</panel-section>\n' + '');
}]);
})();